/* eslint-disable react/no-danger */
/*
 * This illustrates how to create a widget that makes use of a number of different field definition types.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { css } from "styled-components";

// this is used to help ensure that the names match between props.fields and definition.fieldDefinitions[].name
const enum fields {
    jsInjection = "jsInjection",
    htmlInjection = "htmlInjection",
}

interface Props extends WidgetProps {
    fields: {
        [fields.jsInjection]: string;
        [fields.htmlInjection]: string;
    };
}

const testStyles = {
    css: css`
        #test h1 {
            margin: 0;
            padding: 0;
            font-size: initial;
            font-weight: initial;
        }
    `,
};

const TrustedContentWidget: React.FC<Props> = props => {
    React.useEffect(() => {
        const script = document.createElement("script");
        script.type = "application/javascript";
        script.text = props.fields.jsInjection;
        script.async = true;
        document.getElementById("trustedContentWrapper")!.appendChild(script);
    });

    return (
        <StyledWrapper {...testStyles}>
            <div id="trustedContentWrapper">
                <div dangerouslySetInnerHTML={{ __html: props.fields.htmlInjection }} />
            </div>
        </StyledWrapper>
    );
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.jsInjection,
            displayName: "Javascript",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter Javascript code",
            placeholder: "Enter Javascript code",
        },
        {
            name: fields.htmlInjection,
            displayName: "HTML",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter valid HTML",
            placeholder: "Enter HTML",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: TrustedContentWidget,
    definition,
};

export default widgetModule;
